// avoid to append several times jira chat widget (in case user logout and login)
let initialized = false;

function initJiraLiveChat(user: User) {
  if (
    !!process.env.JIRA_CHAT_WIDGET_ID &&
    !!process.env.JIRA_CHAT_WIDGET_SERVICE_DESK_ID &&
    !initialized
  ) {
    // There is some style in app/style.scss for the chat widget
    const chatWidget = document.createElement('chat-widget');
    chatWidget.setAttribute('jira-id', process.env.JIRA_CHAT_WIDGET_ID);
    chatWidget.setAttribute('service-desk-id', process.env.JIRA_CHAT_WIDGET_SERVICE_DESK_ID);

    chatWidget.setAttribute(
      'metadata',
      `[
        { name: 'companyName', value: '${user.company.name}', render: true },
        { name: 'email', value: '${user.email}', render: true },
        ]`
    );
    document.getElementsByTagName('body')[0].appendChild(chatWidget);

    const script = document.createElement('script');
    script.src = 'https://chat-api.spartez-software.com/chat-widget.js';
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);

    initialized = true;
  }
}

export { initJiraLiveChat };
